<template>
    <div class="flex justify-between">
        <div class="flex items-center gap-1">
            <label :for="'input-' + model.name">{{ t(`setting.${model.name}.title`) }}</label>
            <UTooltip
                v-if="shouldShowTooltip"
                :text="helpText"
                :delay-duration="0"
                :ui="{
                    content: 'h-fit overflow-visible',
                    text: 'whitespace-pre-line p-1',
                }"
            >
                <i class="i-ph-info inline-block" />
            </UTooltip>
        </div>
        <bank-account-picker
            v-model="selectedBankAccount"
            class="max-w-md"
            :bank-accounts="bankAccounts"
            @on-bank-account-selected="onBankAccountSelected"
        />
    </div>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import {Setting} from '@/setting/setting.service'
import {useI18n} from 'vue-i18n'
import BankAccountPicker from '@/bank/BankAccountPicker.vue'
import {bankAccounts} from '@/bank/bank-account.service'
import {RichBankAccount} from '@/bank/bank.types'

const {t} = useI18n()

const model = defineModel<Setting<string>>({required: true})
const selectedBankAccount = ref<RichBankAccount | undefined>(
    bankAccounts.value.find(ba => ba.bban === model.value.value)
)

const helpText = computed(() => {
    return t(`setting.${model.value.name}.tooltip`)
})

const shouldShowTooltip = computed(
    () => helpText.value !== ''
)

const onBankAccountSelected = () => {
    if (selectedBankAccount.value) {
        model.value.value = selectedBankAccount.value.bban
    }
}

</script>

<style scoped>

</style>